import { render, staticRenderFns } from "./EncuestaServiciosPage.vue?vue&type=template&id=fec78864&scoped=true&"
import script from "./EncuestaServiciosPage.vue?vue&type=script&lang=js&"
export * from "./EncuestaServiciosPage.vue?vue&type=script&lang=js&"
import style0 from "./EncuestaServiciosPage.vue?vue&type=style&index=0&id=fec78864&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fec78864",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/pages/EncuestaServiciosPage.vue
// module id = 199
// module chunks = 22